import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faTruckFast,
  faShieldHalved,
  faHeadset,
  faRotateLeft,
  faLocationDot,
  faPhone,
  faEnvelope,
  faPaperPlane,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import img_entreprise from "../assets/Images/Logo_entreprise-removebg-preview.webp";
import API from "../Authentification/api";

const EmailRegex = /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

const TRUST_ITEMS = [
  {
    icon: faTruckFast,
    title: "Livraison rapide",
    text: "Partout à Cotonou et environs",
  },
  {
    icon: faShieldHalved,
    title: "Paiement sécurisé",
    text: "Mobile Money, carte bancaire",
  },
  {
    icon: faHeadset,
    title: "Support 7j/7",
    text: "Une question ? On répond vite",
  },
  {
    icon: faRotateLeft,
    title: "Retours faciles",
    text: "Sous 48h après réception",
  },
];

const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterError, setNewsletterError] = useState("");
  const [isSubscribing, setIsSubscribing] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    if (!newsletterEmail.trim()) {
      setNewsletterError("Entrez votre email");
      return;
    }
    if (!EmailRegex.test(newsletterEmail)) {
      setNewsletterError("Email invalide");
      return;
    }

    setNewsletterError("");
    setIsSubscribing(true);

    try {
      const response = await API.post("/newsletter/subscribe", { email: newsletterEmail });
      toast.success(response.data.message || "Merci ! Vous êtes inscrit(e) à notre newsletter.");
      setNewsletterEmail("");
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
        "Impossible de vous inscrire pour le moment, réessayez."
      );
    } finally {
      setIsSubscribing(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="nm-footer">
      {/* Bandeau de confiance */}
      {/* <div className="nm-footer-trust">
        <div className="container-fluid">
          <div className="nm-trust-grid">
            {TRUST_ITEMS.map((item, i) => (
              <div className="nm-trust-item" key={i}>
                <FontAwesomeIcon icon={item.icon} className="nm-trust-icon" />
                <div>
                  <p className="nm-trust-title">{item.title}</p>
                  <p className="nm-trust-text">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* Corps principal */}
      <div className="container-fluid nm-footer-main">
        <div className="row gy-4">
          {/* Marque + contact + réseaux sociaux */}
          <div className="col-lg-3 col-md-6">
            <img
              src={img_entreprise}
              alt="Nol Market"
              className="nm-footer-logo"
            />
            <p className="nm-footer-tagline">
              Votre supermarché en ligne à Cotonou. Faites vos courses
              sans bouger de chez vous.
            </p>
            <ul className="nm-contact-list">
              <li>
                <FontAwesomeIcon icon={faLocationDot} />
                <span>Cotonou, Bénin</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} />
                <a href="tel:+22901650028">01 65 00 28 00</a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} />
                <a href="mailto:contact@nolmarket.com">contact@nolmarket.com</a>
              </li>
            </ul>
            <div className="nm-social-list">
              <a href="#" aria-label="Nol Market sur Facebook" className="nm-social-icon">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a href="#" aria-label="Nol Market sur Instagram" className="nm-social-icon">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="#" aria-label="Nol Market sur X" className="nm-social-icon">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
            </div>
          </div>

          {/* Aide */}
          <div className="col-lg-3 col-md-6">
            <h3 className="nm-footer-heading">Aide</h3>
            <ul className="nm-footer-links">
              <li><Link to="/aide&Faq">FAQ</Link></li>
              <li><Link to="/Contact">Nous contacter</Link></li>
              <li><Link to="/politique-livraison">Livraisons et retours</Link></li>
              <li><Link to="/Contact">Nos boutiques</Link></li>
            </ul>
          </div>

          {/* À propos */}
          <div className="col-lg-3 col-md-6">
            <h3 className="nm-footer-heading">À propos</h3>
            <ul className="nm-footer-links">
              <li><Link to="/About">Notre histoire</Link></li>
              <li><Link to="/conditionUtilisation">Conditions d'utilisation</Link></li>
              <li><Link to="/confidentialite">Politique de confidentialité</Link></li>
              <li><Link to="/mentions-legales">Mentions légales</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="col-lg-3 col-md-6">
            <h3 className="nm-footer-heading">Newsletter</h3>
            <p className="nm-newsletter-text">
              Recevez nos offres et nouveautés directement par email.
            </p>
            <form
              className="nm-newsletter-form"
              onSubmit={handleNewsletterSubmit}
              noValidate
            >
              <div className="nm-newsletter-input-wrap">
                <input
                  type="email"
                  className="nm-newsletter-input"
                  placeholder="Votre email"
                  value={newsletterEmail}
                  onChange={(e) => {
                    setNewsletterEmail(e.target.value);
                    setNewsletterError("");
                  }}
                  aria-label="Votre adresse email"
                  aria-invalid={!!newsletterError}
                />
                <button
                  type="submit"
                  className="nm-newsletter-btn"
                  disabled={isSubscribing}
                  aria-label="S'inscrire à la newsletter"
                >
                  <FontAwesomeIcon icon={faPaperPlane} />
                </button>
              </div>
              {newsletterError && (
                <span className="nm-newsletter-error">{newsletterError}</span>
              )}
            </form>

            <div className="nm-payment-methods">
              <span className="nm-payment-badge">MTN Mobile Money</span>
              <span className="nm-payment-badge">Moov Money</span>
              <span className="nm-payment-badge">Visa</span>
              <span className="nm-payment-badge">Mastercard</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bas de page */}
      <div className="nm-footer-bottom">
        <div className="container-fluid nm-footer-bottom-inner">
          <p className="nm-copyright">
            © {new Date().getFullYear()} Nol Market. Tous droits réservés.
          </p>
          <button
            type="button"
            className="nm-scroll-top"
            onClick={scrollToTop}
            aria-label="Retour en haut de la page"
          >
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
